<template>
  <li
    class="list-group-item px-0 py-1 border-bottom cursor-pointer"
    v-if="
      (contact != undefined &&
        ($store.state.user.unidade.id != 1 && contact.id <= 3
          ? false
          : true)) ||
      contact.unread > 0
    "
    @click="$emit('selected', contact)"
  >
    <div class="contact d-flex flex-row justify-content-between">
      <b class="name d-flex align-items-center">
        <i
          v-if="selected"
          class="mdi mdi-24px mdi-chevron-right-circle text-primary"
        ></i>
        {{ contact.name }}
        <i
          v-if="contact.id <= 3"
          class="mdi mdi-dev-to mdi-24px text-warning"
        ></i>
      </b>
      <span>
        <span class="unread mx-2" v-if="contact.unread">
          {{ contact.unread }}
        </span>
        <span v-else v-for="user in userOnline" :key="user.userID">
          <span
            v-if="user.userID == contact.id"
            class="availability-status online"
          >
            <i class="fa fa-circle" aria-hidden="true"></i>
          </span>
        </span>
      </span>
    </div>
  </li>
</template>
<script>
export default {
  props: {
    contact: {
      type: Object,
    },
    online: { type: Boolean, default: false },
    selected: { type: Boolean, default: false },
  },
  computed: {
    userOnline() {
      return this.$store.state.users;
    },
  },
};
</script>

<style lang="scss" scoped>
.unread {
  background: #fb8994;
  color: #fff;
  right: 11px;
  min-width: 20px;
  /* top: 20px; */
  align-items: center;
  line-height: 20px;
  font-size: 12px;
  padding: 4px 8px;
  /* float: right; */
  z-index: 1010;
  /* position: absolute; */
  text-align: center;
  border-radius: 10px;
}
.availability-status {
  font-size: 8px;
}
.availability-status.online {
  color: #1bcfb4;
}
.availability-status .offline {
  background: #ccc;
}
.cursor-pointer {
  cursor: pointer;
}
</style>
